export { Datacenter } from '@datadog/browser-core';
export { StatusType, HandlerType, Logger } from './domain/logger';
export { datadogLogs } from './boot/logs.entry';
//# sourceMappingURL=index.js.map